import React from "react";

export default () =>
  <p>&copy; {new Date().getFullYear()} Copyright: Mat Selleck</p>;